/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEmailSchedule = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M2 2v18h10v-2H4V5.227l8 7.111 8-7.111V12h2V2zm10 7.662L5.63 4h12.74z" />
        <path d="M14 18a4 4 0 1 1 8 0 4 4 0 0 1-8 0zm3.5.208 1.146 1.146.707-.707-.853-.854V16h-1z" />
      </g>
    </g>
  </Icon>
);
export { SvgEmailSchedule as EmailSchedule };
